import RequestAbstract from "./RequestAbstract";

export default class FacebookPages extends RequestAbstract {
  get link() {
    return "facebook/pages";
  }

  // Mock данные для локального тестирования
  getMockPages() {
    return {
      isOk: true,
      message: "Using mock data for demonstration",
      data: [
        {
          id: 1,
          page_id: "123456789",
          name: "My Business Page",
          avatar: "https://picsum.photos/seed/business/50/50",
          details: {
            page_id: "123456789",
            name: "My Business Page",
          },
        },
        {
          id: 2,
          page_id: "987654321",
          name: "Another Page",
          avatar: "https://picsum.photos/seed/another/50/50",
          details: {
            page_id: "987654321",
            name: "Another Page",
          },
        },
      ],
    };
  }

  normalizePagesList(data) {
    const items = Array.isArray(data)
      ? data
      : Array.isArray(data?.items)
        ? data.items
        : [];

    return items.map((item) => {
      const primaryAccountId =
        Array.isArray(item.accounts) && item.accounts.length > 0
          ? item.accounts[0]
          : item.page_id || item.id;
      const name =
        item.title || item.name || `Page ${primaryAccountId || item.id}`;

      return {
        id: primaryAccountId || item.id,
        accountId: primaryAccountId || item.id,
        name,
        avatar: item.avatar || item.picture || null,
        details: {
          page_id: primaryAccountId || item.page_id || item.id,
          name,
        },
      };
    });
  }

  getMockFeed() {
    return {
      isOk: true,
      message: "Using mock data",
      data: {
        page_id: "123456789",
        page_name: "My Business Page",
        posts: [
          {
            id: "123_456",
            message:
              "This is our latest product launch! 🚀 Check out the amazing features we've added.",
            type: "status",
            created_time: new Date(Date.now() - 86400000).toISOString(),
            picture: "https://picsum.photos/seed/product1/600/400",
            permalink_url: "https://facebook.com/post1",
            engagement: {
              likes: 245,
              comments: 32,
              shares: 18,
            },
          },
          {
            id: "123_457",
            message:
              "Join us for our upcoming webinar on digital marketing strategies.",
            type: "status",
            created_time: new Date(Date.now() - 172800000).toISOString(),
            picture: "https://picsum.photos/seed/webinar/600/400",
            permalink_url: "https://facebook.com/post2",
            engagement: {
              likes: 156,
              comments: 24,
              shares: 12,
            },
          },
        ],
      },
    };
  }

  getMockPhotos() {
    return {
      isOk: true,
      message: "Using mock data",
      data: {
        page_id: "123456789",
        page_name: "My Business Page",
        photos: [
          {
            id: "ph_1",
            image_url: "https://picsum.photos/seed/team1/300/300",
            name: "Team photo at conference",
            created_time: new Date(Date.now() - 86400000).toISOString(),
            engagement: {
              likes: 89,
              comments: 12,
            },
          },
          {
            id: "ph_2",
            image_url: "https://picsum.photos/seed/product2/300/300",
            name: "Product showcase",
            created_time: new Date(Date.now() - 172800000).toISOString(),
            engagement: {
              likes: 156,
              comments: 24,
            },
          },
          {
            id: "ph_3",
            image_url: "https://picsum.photos/seed/office1/300/300",
            name: "Office celebration",
            created_time: new Date(Date.now() - 259200000).toISOString(),
            engagement: {
              likes: 234,
              comments: 45,
            },
          },
        ],
      },
    };
  }

  getMockVideos() {
    return {
      isOk: true,
      message: "Using mock data",
      data: {
        page_id: "123456789",
        page_name: "My Business Page",
        videos: [
          {
            id: "vid_1",
            title: "Product Demo - New Features",
            description:
              "Learn about the amazing new features in our latest update",
            source: "https://picsum.photos/seed/video1/500/300",
            picture: "https://picsum.photos/seed/video1/500/300",
            length: 245,
            created_time: new Date(Date.now() - 86400000).toISOString(),
            engagement: {
              likes: 523,
              comments: 87,
            },
          },
          {
            id: "vid_2",
            title: "Customer Success Story",
            description: "How our clients achieved amazing results",
            source: "https://picsum.photos/seed/video2/500/300",
            picture: "https://picsum.photos/seed/video2/500/300",
            length: 420,
            created_time: new Date(Date.now() - 172800000).toISOString(),
            engagement: {
              likes: 345,
              comments: 56,
            },
          },
        ],
      },
    };
  }

  getMockInsights() {
    return {
      isOk: true,
      message: "Using mock data",
      data: {
        page_id: "123456789",
        page_name: "My Business Page",
        insights: {
          page_fans: 5420,
          page_engaged_users: 1850,
          page_post_engagements: 8945,
          page_impressions: 45320,
        },
      },
    };
  }

  getMockPageInfo() {
    return {
      isOk: true,
      message: "Using mock data",
      data: {
        id: "123456789",
        name: "My Business Page",
        username: "mybusinesspage",
        about:
          "We are a leading business providing innovative solutions to our customers worldwide.",
        category: "Business Service",
        fan_count: 5420,
        followers_count: 5820,
        picture: {
          data: {
            url: "https://picsum.photos/seed/pageinfo/200/200",
          },
        },
        cover: {
          source: "https://picsum.photos/seed/cover/500/200",
        },
        link: "https://facebook.com/mybusinesspage",
        verification_status: "verified",
      },
    };
  }

  /**
   * Helper method to handle API calls with timeout and error handling
   * Silently falls back to mock data without showing error alerts
   * @param {Function} apiCall - The API call function
   * @param {number} timeout - Timeout in milliseconds (default: 10000)
   * @returns {Promise} Promise with API response or error
   */
  async callWithTimeout(apiCall, timeout = 10000) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const result = await apiCall();
      clearTimeout(timeoutId);

      // If result has error property, return it as silent error (no toast)
      if (result?.error && !result?.isOk) {
        return { error: "api_error", data: result.error, silent: true };
      }

      return result;
    } catch (error) {
      clearTimeout(timeoutId);

      if (error.name === "AbortError") {
        return {
          error: "timeout",
          data: "Request timeout. Backend server is not responding.",
          silent: true,
        };
      }

      return {
        error: "network_error",
        data: error.message || "Network error occurred",
        silent: true,
      };
    }
  }

  /**
   * Get list of user's Facebook pages
   * Required for pages_show_list permission
   * @returns {Promise} Promise with pages list
   */
  async getList() {
    const url = this.link + "/list";

    // Сначала пытаемся получить с backend (silent - без показа ошибок)
    const response = await this.callWithTimeout(
      () => this.getSilent(url),
      5000,
    );

    const normalizedPages = this.normalizePagesList(response?.data);

    // Если backend не ответил или вернул пустой массив, возвращаем mock данные
    if (response?.error || normalizedPages.length === 0) {
      return this.getMockPages();
    }

    return {
      ...response,
      data: normalizedPages,
    };
  }

  /**
   * Get page feed (posts) with engagement data
   * Required for pages_read_engagement permission
   * @param {string|number} accountId - Facebook page account ID
   * @param {number} limit - Number of posts to retrieve (default: 10)
   * @returns {Promise} Promise with page feed data
   */
  async getFeed(accountId, limit = 10) {
    const url = `${this.link}/${accountId}/feed?limit=${limit}`;

    const response = await this.callWithTimeout(
      () => this.getSilent(url),
      5000,
    );

    if (response?.error) {
      return this.getMockFeed();
    }

    return response;
  }

  /**
   * Get page photos with engagement data
   * Required for pages_read_engagement permission
   * @param {string|number} accountId - Facebook page account ID
   * @param {number} limit - Number of photos to retrieve (default: 10)
   * @returns {Promise} Promise with photos data
   */
  async getPhotos(accountId, limit = 10) {
    const url = `${this.link}/${accountId}/photos?limit=${limit}`;

    const response = await this.callWithTimeout(
      () => this.getSilent(url),
      5000,
    );

    if (response?.error) {
      return this.getMockPhotos();
    }

    return response;
  }

  /**
   * Get page videos with engagement data
   * Required for pages_read_engagement permission
   * @param {string|number} accountId - Facebook page account ID
   * @param {number} limit - Number of videos to retrieve (default: 10)
   * @returns {Promise} Promise with videos data
   */
  async getVideos(accountId, limit = 10) {
    const url = `${this.link}/${accountId}/videos?limit=${limit}`;

    const response = await this.callWithTimeout(
      () => this.getSilent(url),
      5000,
    );

    if (response?.error) {
      return this.getMockVideos();
    }

    return response;
  }

  /**
   * Get page insights and engagement metrics
   * Required for pages_read_engagement permission
   * @param {string|number} accountId - Facebook page account ID
   * @returns {Promise} Promise with insights data
   */
  async getInsights(accountId) {
    const url = `${this.link}/${accountId}/insights`;

    const response = await this.callWithTimeout(
      () => this.getSilent(url),
      5000,
    );

    if (response?.error) {
      return this.getMockInsights();
    }

    return response;
  }

  /**
   * Get page information including followers count and verification status
   * @param {string|number} accountId - Facebook page account ID
   * @returns {Promise} Promise with page info
   */
  async getInfo(accountId) {
    const url = `${this.link}/${accountId}/info`;

    const response = await this.callWithTimeout(
      () => this.getSilent(url),
      5000,
    );

    if (response?.error) {
      return this.getMockPageInfo();
    }

    return response;
  }
}
